import bus from '~/bus'
import {getEventFile} from '~/helpers/eventHelper'
import router from '~/router'

export default {
  name: 'moved',
  do: function (payload) {
    console.log('DEBUG moved: ', this, payload)
    if (this.file === payload.file_id || (this.fileAncestors && this.fileAncestors.includes(payload.file_id))) {
      getEventFile(payload.deprecated_file_id).then((response) => {
        bus.$emit('refreshAppbar', response)
      })
    }
    if (router.app.$route.name !== 'mysearch' &&
      (this.file === payload.old_parent_id || (this.file === 'myspace' && payload.old_parent_id === ''))
    ) {
      bus.$emit('deleteFile', payload.deprecated_file_id) // TODO refactor do directly instead of event when migrate all to Vue3
    }
    if (this.file === payload.parent_id) {
      getEventFile(payload.deprecated_file_id).then((response) => {
        bus.$emit('insertFile', response)
        this.fileChildren.push(payload.file_id)
      })
    }
    if (this.fileChildren && this.fileChildren.includes(payload.old_parent_id)) {
      getEventFile(payload.deprecated_old_parent_id).then((response) => {
        bus.$emit('updateFile', response)
      })
    }
    if (this.fileChildren && this.fileChildren.includes(payload.parent_id)) {
      getEventFile(payload.deprecated_parent_id).then((response) => {
        bus.$emit('updateFile', response)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/moved.js